<div>
  @switch (entryType) {
    @case ('ChatInfo') {
      <app-chat-timeline-info-entry [entry]="entry"></app-chat-timeline-info-entry>
    }
    @case ('ParticipantMessages') {
      <app-chat-timeline-participant-messages-entry
        [entry]="entry"
        (markAsRead)="markAsRead.emit($event)"
        (messageAdded)="participantMessageAdded.emit($event)"
      (upgradeClicked)="upgradeClicked.emit()"></app-chat-timeline-participant-messages-entry>
    }
    @case ('ParticipantChange') {
      <app-chat-timeline-participant-change-entry
      [entry]="entry"></app-chat-timeline-participant-change-entry>
    }
    @case ('PendingMessages') {
      <app-chat-timeline-pending-messages-entry
        [entry]="entry"
        (retrySendMessage)="retrySendMessage.emit($event)"
      (messageAdded)="pendingMessageAdded.emit($event)"></app-chat-timeline-pending-messages-entry>
    }
    @case ('UnreadTidemark') {
      <app-chat-timeline-unread-tidemark
      [entry]="entry"></app-chat-timeline-unread-tidemark>
    }
  }
</div>
